"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _selectors = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var _Modal = _interopRequireDefault(require("../../../../../../../Modal"));
var _constants = require("../../../../../../../Modal/constants");
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _Alert = _interopRequireWildcard(require("../../../../../../../ui/Alert"));
var _selectors2 = require("../../../BookingServices/store/selectors");
var _selectors3 = require("../../store/selectors");
var _SuccessMsg = require("../SuccessMsg");
var _BookingProgressSteper = require("../BookingProgressSteper");
var _selectors4 = require("./store/selectors");
var _styles = _interopRequireDefault(require("./styles"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var BookingResultModal = function BookingResultModal(_ref) {
  var queryID = _ref.queryID,
    onConfirmBooking = _ref.onConfirmBooking,
    onClose = _ref.onClose;
  var bookingOfferByOperatorUI = (0, _reactRedux.useSelector)(_selectors3.getBookingOfferByOperatorUI);
  var fetchBookingServicesUI = (0, _reactRedux.useSelector)(_selectors2.getFetchBookingServicesUI);
  var recalculateOfferPriceUI = (0, _reactRedux.useSelector)(_selectors2.getRecalculateOfferPriceUI);
  var currencyCode = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getQueryParam)(state, {
      paramName: _fn.QUERY_PARAMS.CURRENCY,
      queryID: queryID
    });
  });
  var isPriceChanged = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors4.getIsPriceChanged)(state, {
      currencyCode: currencyCode
    });
  });
  var isShowConfirmationMessage = (0, _reactRedux.useSelector)(_selectors3.getIsShowConfirmationMessage);
  var price = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors4.getRecalculateOfferPrice)(state, {
      currencyCode: currencyCode
    });
  });
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_RESULT_MODAL'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    closeIcon: true,
    size: _constants.SIZES.TINY,
    onClose: onClose
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    withoutHeader: true
  }, /*#__PURE__*/_react.default.createElement(_BookingProgressSteper.BookingProgressSteper, null), isPriceChanged && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default['margin-30'],
    type: _Alert.TYPES.DANGER
  }, t('PRICE_CHANGE_ALERT', {
    price: price,
    currency: (0, _dictionary.getCurrencyByCode)(currencyCode).label
  })), (fetchBookingServicesUI.error || recalculateOfferPriceUI.error) && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default['margin-30'],
    type: _Alert.TYPES.DANGER,
    withHTML: true
  }, t('FETCH_SERIVCES_ERROR')), isShowConfirmationMessage && /*#__PURE__*/_react.default.createElement(_SuccessMsg.SuccessMsg, {
    className: _styles.default['margin-30']
  }), bookingOfferByOperatorUI.error && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    className: _styles.default['margin-30'],
    type: _Alert.TYPES.ERROR
  }, bookingOfferByOperatorUI.message), isPriceChanged && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.buttons
  }, !isShowConfirmationMessage && /*#__PURE__*/_react.default.createElement(_Button.default, {
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    disabled: !fetchBookingServicesUI.completed || !recalculateOfferPriceUI.completed,
    theme: _Button.THEMES.PURPLE,
    onClick: onConfirmBooking
  }, t('ON_CONFIRM_BOOKING_BUTTON')), /*#__PURE__*/_react.default.createElement(_Button.default, {
    fontFamily: _Button.FONT_FAMILIES.REGULAR,
    theme: _Button.THEMES.WHITE,
    onClick: onClose
  }, t(isShowConfirmationMessage ? 'CLOSE_BUTTON_SUCCESS_TITLE' : 'CLOSE_BUTTON')))));
};
BookingResultModal.propTypes = {
  queryID: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func.isRequired,
  onConfirmBooking: _propTypes.default.func.isRequired
};
var _default = exports.default = BookingResultModal;